var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 18.9585V11.6668M4.87514 17.5001C4.87514 10.2514 10.7514 4.37509 18.0002 4.37509C25.249 4.37509 31.1252 10.2514 31.1252 17.5001C31.1252 24.7489 25.249 30.6252 18.0002 30.6252C10.7514 30.6252 4.87514 24.7489 4.87514 17.5001Z",
    stroke: "#F9FAFC",
    strokeWidth: 2.91668,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9999,
    cy: 24.0626,
    r: 1.45834,
    transform: "rotate(180 17.9999 24.0626)",
    fill: "#F9FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.77d2ee69554cdc6781ce794859b42250.svg";
export { ForwardRef as ReactComponent };